module.exports = __webpack_public_path__ + "static/media/local_fire_department.3b723a9f.svg";